// extracted by mini-css-extract-plugin
export var bubble = "_1g-0";
export var container = "_1g-f";
export var contrastBorder = "_1g-g";
export var greyOut = "_1g-2";
export var initialsColor0 = "_1g-3";
export var initialsColor1 = "_1g-4";
export var initialsColor10 = "_1g-d";
export var initialsColor11 = "_1g-e";
export var initialsColor2 = "_1g-5";
export var initialsColor3 = "_1g-6";
export var initialsColor4 = "_1g-7";
export var initialsColor5 = "_1g-8";
export var initialsColor6 = "_1g-9";
export var initialsColor7 = "_1g-a";
export var initialsColor8 = "_1g-b";
export var initialsColor9 = "_1g-c";
export var initialsWrapper = "_1g-1";
export var large = "_1g-l";
export var medium = "_1g-k";
export var mediumSmall = "_1g-j";
export var mediumSmallMedium = "_1g-o";
export var micro = "_1g-h";
export var small = "_1g-i";
export var tiny = "_1g-n";
export var xTiny = "_1g-m";